import { useState } from 'react';
import { ALL_PALETTE_COLORS, COLOR_PALETTE } from './compileDocument';

/**
 * S83.1 — Selector de color con paleta curada multi-vertical + hex libre.
 */
export default function ColorPalette({ label, value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const current = value || '#F72585';

  return (
    <div className="space-y-1" data-testid={testId || 'color-palette'}>
      {label && (
        <label className="text-[10px] font-medium text-[#64748B] block">{label}</label>
      )}
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => setOpen(o => !o)}
          className="w-9 h-9 rounded-lg border-2 border-white shadow ring-1 ring-[#E2E8F0] shrink-0"
          style={{ background: current }}
          title={current}
          data-testid={testId ? `${testId}-swatch` : 'color-swatch'}
          aria-label="Abrir paleta"
        />
        <input
          type="text"
          value={current}
          onChange={e => onChange(e.target.value)}
          className="flex-1 h-8 text-xs font-mono border border-[#E2E8F0] rounded-lg px-2"
          placeholder="#F72585"
          data-testid={testId ? `${testId}-hex` : 'color-hex'}
        />
        <input
          type="color"
          value={/^#[0-9A-Fa-f]{6}$/.test(current) ? current : '#F72585'}
          onChange={e => onChange(e.target.value)}
          className="w-8 h-8 p-0 border-0 bg-transparent cursor-pointer"
          title="Selector nativo"
        />
      </div>

      {open && (
        <div className="mt-1 p-2 bg-white border border-[#E2E8F0] rounded-xl shadow-lg space-y-2 z-10 relative"
          data-testid="color-palette-pop">
          {Object.entries(COLOR_PALETTE).map(([group, colors]) => (
            <div key={group}>
              <p className="text-[9px] font-bold uppercase tracking-wide text-[#94A3B8] mb-1">
                {group === 'marca' ? 'Marca' : group === 'verticales' ? 'Verticales' : 'Neutros'}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {colors.map(c => (
                  <button
                    key={c.hex + c.name}
                    type="button"
                    title={`${c.name} ${c.hex}`}
                    onClick={() => { onChange(c.hex); setOpen(false); }}
                    className={`w-7 h-7 rounded-md border-2 transition-transform hover:scale-110 ${
                      current.toLowerCase() === c.hex.toLowerCase()
                        ? 'border-[#0F172A] ring-2 ring-[#F72585]/40'
                        : 'border-white ring-1 ring-[#E2E8F0]'
                    }`}
                    style={{ background: c.hex }}
                    data-testid={`palette-${c.hex.replace('#', '')}`}
                  />
                ))}
              </div>
            </div>
          ))}
          <div className="flex flex-wrap gap-1 pt-1 border-t border-[#F1F5F9]">
            {ALL_PALETTE_COLORS.slice(0, 12).map(c => (
              <span key={c.hex + 't'} className="text-[8px] text-[#94A3B8] font-mono">{c.hex}</span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
